export default __webpack_public_path__ + "static/media/amanase-logo.ad597f29.png";